export const decrypt = async (code: string): Promise<string> => {
    const res = await window.fetch(`${process.env.REACT_APP_API_URL}/decrypt?code=${code}`, {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    })
    return res.json()
}